module.exports = __webpack_public_path__ + "img/loading-linza-transparent.8cdc061.gif?v=1753181944267";